import { createSlice } from '@reduxjs/toolkit';
import { getEnrollmentClientConfigurations } from './api-calls/enrollmentClientConfig';

export const enrollmentClientConfigSlice = createSlice({
  name: 'enrollmentClientConfig',
  initialState: { enrollmentContent: {} },
  reducers: {
    setEnrollmentContent: (state, action) => {
      state.enrollmentContent = action.payload;
    },
  },
  extraReducers: {
    [getEnrollmentClientConfigurations.pending]: () => {},
    [getEnrollmentClientConfigurations.fulfilled]: (state, action) => {
      state.enrollmentContent =
        action.payload.data.Response.Clientconfiguration.configuration;
    },
    [getEnrollmentClientConfigurations.rejected]: (state) => {
      state.enrollmentContent = {};
    },
  },
});

export const { setEnrollmentContent } = enrollmentClientConfigSlice.actions;
export default enrollmentClientConfigSlice.reducer;
